// ── MODAL ──
let modalSlides = [], modalCurrentSlide = 0;
let currentProduct = null;

function openProductModal(productId) {
  const products = window.SHOPIFY_PRODUCTS || [];
  currentProduct = products.find(p => p.id == productId);
  if (!currentProduct) return;

  modalSlides = [];
  if (currentProduct.images) {
    currentProduct.images.forEach((src, i) => modalSlides.push({ src, type: i === 0 ? 'spec' : 'photo' }));
  }

  const track = document.getElementById('modal-gallery-track');
  const dotsEl = document.getElementById('modal-dots');
  if (track) {
    track.innerHTML = modalSlides.map(s =>
      '<div class="modal-gallery-slide' + (s.type === 'photo' ? ' photo' : '') + '"><img src="' + s.src + '" loading="lazy"></div>'
    ).join('');
  }
  if (dotsEl) {
    dotsEl.innerHTML = modalSlides.map((_, i) =>
      '<div class="modal-dot' + (i === 0 ? ' active' : '') + '" onclick="goToSlide(' + i + ')"></div>'
    ).join('');
  }

  const nameEl = document.getElementById('modal-name');
  const metaEl = document.getElementById('modal-meta');
  const descEl = document.getElementById('modal-desc');
  const priceEl = document.getElementById('modal-price');
  const moqEl = document.getElementById('modal-moq');
  const turnaroundEl = document.getElementById('modal-turnaround');

  if (nameEl) nameEl.textContent = currentProduct.title;
  if (metaEl) metaEl.textContent = currentProduct.deco || '';
  if (descEl) descEl.textContent = currentProduct.desc || '';
  if (priceEl) priceEl.textContent = currentProduct.price_min + (currentProduct.price_max !== currentProduct.price_min ? '–' + currentProduct.price_max : '');
  if (moqEl) moqEl.textContent = currentProduct.moq + ' pcs';
  if (turnaroundEl) turnaroundEl.innerHTML = '<span style="font-family:monospace;font-size:0.62rem;letter-spacing:0.15em;text-transform:uppercase;color:var(--charcoal);font-weight:600;display:block;margin-bottom:8px;">Turnaround</span><div style="font-size:0.88rem;color:var(--charcoal);">' + (currentProduct.turnaround || '4–6 weeks') + '</div>';

  modalCurrentSlide = 0;
  updateModalSlide();
  document.getElementById('product-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  const modal = document.getElementById('product-modal');
  if (modal) modal.classList.remove('open');
  document.body.style.overflow = '';
}

function handleModalOverlayClick(e) {
  if (e.target.id === 'product-modal') closeModal();
}

function modalSlide(dir) {
  modalCurrentSlide = (modalCurrentSlide + dir + modalSlides.length) % modalSlides.length;
  updateModalSlide();
}

function goToSlide(idx) {
  modalCurrentSlide = idx;
  updateModalSlide();
}

function updateModalSlide() {
  const track = document.getElementById('modal-gallery-track');
  if (track) track.style.transform = 'translateX(-' + (modalCurrentSlide * 100) + '%)';
  document.querySelectorAll('.modal-dot').forEach((d, i) => {
    d.classList.toggle('active', i === modalCurrentSlide);
  });
}

// ── ORDER FORM ──
function submitOrderForm() {
  const checked = document.getElementById('terms-check');
  if (!checked || !checked.checked) { alert('Please agree to the Terms of Service before submitting.'); return; }
  document.querySelectorAll('.order-card').forEach(c => c.style.display = 'none');
  const success = document.getElementById('order-success');
  if (success) success.style.display = 'block';
  window.scrollTo(0, 0);
}

// ── TOAST ──
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

// ── FAQ ACCORDION ──
function toggleFaq(btn) {
  btn.parentElement.classList.toggle('open');
}
